import React from 'react';
import { PortalProvider } from '../../contexts/PortalContext';
import PortalLayout          from './PortalLayout';
import PortalDashboardPage   from './PortalDashboardPage';
import PortalMattersPage     from './PortalMattersPage';
import PortalMatterDetailPage from './PortalMatterDetailPage';
import PortalInvoicesPage    from './PortalInvoicesPage';
import PortalReceiptsPage    from './PortalReceiptsPage';
import PortalMessagesPage    from './PortalMessagesPage';
import { useRoute, matchRoute } from '../../lib/router';

function PortalRouter() {
  const [{ pathname, segments }] = useRoute();

  // /portal/matters/:id
  const matterDetail = matchRoute(segments, 'portal/matters/:id');
  if (matterDetail) return <PortalMatterDetailPage matterId={matterDetail.id} />;

  switch (pathname) {
    case '/portal':          return <PortalDashboardPage />;
    case '/portal/matters':  return <PortalMattersPage />;
    case '/portal/invoices':  return <PortalInvoicesPage />;
    case '/portal/receipts':  return <PortalReceiptsPage />;
    case '/portal/messages':  return <PortalMessagesPage />;
    default:                 return <PortalDashboardPage />;
  }
}

export default function PortalApp() {
  return (
    <PortalProvider>
      <PortalLayout>
        <PortalRouter />
      </PortalLayout>
    </PortalProvider>
  );
}
